/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetZoneTemplatesQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type GetZoneTemplatesQuery = { __typename: 'Query', getLabelTemplates: Array<{ __typename: 'LabelTemplate', id: string | null, template_type: Types.LabelTemplateType, template: string | null, label_id: number | null }> | null };


export const GetZoneTemplatesDocument = gql`
    query getZoneTemplates($id: String!) {
  getLabelTemplates(id: $id) {
    id
    template_type
    template
    label_id
  }
}
    `;

/**
 * __useGetZoneTemplatesQuery__
 *
 * To run a query within a React component, call `useGetZoneTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZoneTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZoneTemplatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetZoneTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetZoneTemplatesQuery, GetZoneTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZoneTemplatesQuery, GetZoneTemplatesQueryVariables>(GetZoneTemplatesDocument, options);
      }
export function useGetZoneTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZoneTemplatesQuery, GetZoneTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZoneTemplatesQuery, GetZoneTemplatesQueryVariables>(GetZoneTemplatesDocument, options);
        }
export type GetZoneTemplatesQueryHookResult = ReturnType<typeof useGetZoneTemplatesQuery>;
export type GetZoneTemplatesLazyQueryHookResult = ReturnType<typeof useGetZoneTemplatesLazyQuery>;